export default __webpack_public_path__ + "static/media/notFound.6c8cf219.png";